var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    rx: 150,
    fill: "url(#paint0_linear_14504_2215)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.38 169.16C151.84 172.42 153.29 173.76 154.71 175.14C164.74 184.9 174.79 194.63 184.75 204.44C187.27 206.92 189.61 207.79 192.44 205.01C208.51 189.29 224.6 173.59 240.69 157.88C243.03 155.59 243.12 153.31 240.74 150.98C237.88 148.19 234.93 145.48 232.21 142.55C229.02 139.12 226.24 139.22 222.94 142.55C215.09 150.47 207.04 158.21 199.05 166C195.65 169.32 192.19 172.58 188.63 175.98C177.02 164.64 165.83 153.7 154.63 142.78C150.46 138.72 149.38 138.72 145.17 142.81C140.63 147.22 136.1 151.64 131.56 156.05C124.8 162.63 118.04 169.2 111.12 175.93C109.54 174.43 108.33 173.31 107.15 172.16C97.14 162.39 87.16 152.59 77.13 142.83C72.78 138.59 71.77 138.63 67.28 142.96C64.88 145.27 62.62 147.74 60.11 149.91C56.47 153.07 56.78 155.72 60.2 158.99C75.36 173.5 90.35 188.18 105.42 202.78C111.19 208.37 111.67 208.5 117.35 202.51C127.69 191.64 137.8 180.57 148.38 169.16ZM150.03 93.6904C127.43 94.0004 108.3 102.2 92.53 118.42C89.44 121.6 89.66 123.94 92.78 126.72C95.76 129.37 98.73 132.08 101.34 135.08C104.09 138.23 105.9 137.78 109.02 135.17C115.08 130.1 121.25 124.66 128.31 121.36C149.26 111.57 172.72 116.68 190.03 134.04C193.31 137.34 195.59 138.03 198.78 134.2C201.11 131.4 203.86 128.93 206.6 126.51C209.93 123.56 209.99 121.06 206.76 117.79C191.11 101.97 172.2 94.0404 150.03 93.6904Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14504_2215",
    x1: 0,
    y1: 150,
    x2: 300,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C9CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.d4077c1495660fcb8a1d0bfab4938f3c.svg";
export { ForwardRef as ReactComponent };